import { IUsersTableTab } from '@lib/users.interface';

export const REJECT_USER_DIALOG_HEIGHT: string = '98vh';

export enum TABS_LIST {
  ACTIVE = 'Active',
  OPT_IN_PENDING = 'Pending',
  OPT_IN_DECLINE = 'Decline',
  OPT_IN_EMAIL_SENT = 'Email_Sent',
  SIGN_UP_PENDING = 'Sign up Pending',
  SIGN_UP_DECLINE = 'Sign up Decline',
};

export enum OPT_IN_FILTERS {
  ACCEPT = 'opt_in_accept',
  DECLINE = 'opt_in_reject',
  PENDING = 'opt_in_pending',
  EMAIL = 'opt_in_email_sent',
};

export enum SIGN_UP_FILTERS {
  SIGNUP_REJECT = 'signup_rejected',
  SIGNUP_APPROVED = 'signup_approved',
  ADMIN_PENDING = 'admin_approval_pending',
  SIGNUP_PENDING = 'signup_verification_pending',
};

export type TabsType = {
  [key in TABS_LIST]: string;
};

export type OptInFiltersType = {
  [key in string]: OPT_IN_FILTERS;
};

export type SignupFiltersType = {
  [key in string]: SIGN_UP_FILTERS;
};

export const UsersTableTabs: TabsType = {
  [TABS_LIST.ACTIVE]: 'Active',
  [TABS_LIST.OPT_IN_PENDING]: 'Opt-In Pending',
  [TABS_LIST.OPT_IN_DECLINE]: 'Opt-In Rejected',
  [TABS_LIST.SIGN_UP_PENDING]: 'Signup Pending',
  [TABS_LIST.SIGN_UP_DECLINE]: 'Signup Rejected',
  [TABS_LIST.OPT_IN_EMAIL_SENT]: 'Opt-In Email Sent',
};

export const OPT_IN_FILTERS_MAPPING: OptInFiltersType = {
  Email: OPT_IN_FILTERS.EMAIL,
  Pending: OPT_IN_FILTERS.PENDING,
  Decline: OPT_IN_FILTERS.DECLINE,
};

export const SIGN_UP_FILTERS_MAPPING: SignupFiltersType = {
  Approved: SIGN_UP_FILTERS.SIGNUP_APPROVED,
  AdminReject: SIGN_UP_FILTERS.SIGNUP_REJECT,
  AdminPending: SIGN_UP_FILTERS.ADMIN_PENDING,
  SignupPending: SIGN_UP_FILTERS.SIGNUP_PENDING,
};

export const OPT_IN_TABS: IUsersTableTab[] = [
  {
    totalEntities: 0,
    id: OPT_IN_FILTERS_MAPPING.Pending,
    filter: OPT_IN_FILTERS_MAPPING.Pending,
    title: UsersTableTabs[TABS_LIST.OPT_IN_PENDING],
  },
  {
    totalEntities: 0,
    id: OPT_IN_FILTERS_MAPPING.Decline,
    filter: OPT_IN_FILTERS_MAPPING.Decline,
    title: UsersTableTabs[TABS_LIST.OPT_IN_DECLINE],
  },
  {
    totalEntities: 0,
    id: OPT_IN_FILTERS_MAPPING.Email,
    filter: OPT_IN_FILTERS_MAPPING.Email,
    title: UsersTableTabs[TABS_LIST.OPT_IN_EMAIL_SENT],
  },
];

export const SIGN_UP_TABS: IUsersTableTab[] = [
  {
    totalEntities: 0,
    id: SIGN_UP_FILTERS_MAPPING.AdminPending,
    filter: SIGN_UP_FILTERS_MAPPING.AdminPending,
    title: UsersTableTabs[TABS_LIST.SIGN_UP_PENDING],
  },
  {
    totalEntities: 0,
    id: SIGN_UP_FILTERS_MAPPING.AdminReject,
    filter: SIGN_UP_FILTERS_MAPPING.AdminReject,
    title: UsersTableTabs[TABS_LIST.SIGN_UP_DECLINE],
  },
];

export const TABS: IUsersTableTab[] = [
  {
    id: 'active',
    filter: 'active',
    totalEntities: 0,
    title: UsersTableTabs[TABS_LIST.ACTIVE],
  },
];
